import React from 'react'
import { CustomAccordian } from '../../CommonComponent'
import './fulfillmentsummary.scss';
import ItemSummary from './ItemSummary';
import { Iprops } from './fullfilmentsummaryinterface';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import TickBlue from '../../../assets/images/tickmarkblue.svg';
import Loader from '../../Loader';
import { Tooltip } from "@progress/kendo-react-tooltip";

const FulfillmentSummary = (props: Iprops) => {
    const { t } = useTranslation();
    return (
        <div className='fulfillmentWrapper mb-3'>
            <div className='heading-wrapper mb-1 clearfix'>
                <div className='heading mt-4'>{t(RESOURCE.Myk_Info_SC_FAS_Header)}</div>
            </div>
            <div className="alert infogray mb-4">
                <div className='alert_container'>
                    <span className='img_wrapper'><img src={TickBlue} /></span>
                    <span>
                        <p>{t(RESOURCE.Myk_Info_SC_FAS_HeaderDetailTitle)}</p>
                        <p className='mt-4'>{t(RESOURCE.Myk_Info_SC_FAS_HeaderDetailDescription)}
                        </p>
                    </span>
                </div>
            </div>
            {props.availabilityDetails?.loading && <Loader/>}
            <div className='accordianview clearfix'>
                {Array.isArray(props?.availabilityDetails?.data) && props?.availabilityDetails?.data.map((data: any) => {
                    return <CustomAccordian
                        key={data?.branchCode}
                        title={<Tooltip anchorElement="target" position="bottom"><span className='heading' title={data?.title}>{data?.isOrderingBranch && <span className='fa fa-map-marker mr-2'></span>}<span></span>{data?.title}</span></Tooltip>}
                        content={<ItemSummary partData={data} />}
                        collapse={false}
                        onMakeThisDefault={props?.onMakeThisDefault}
                        data={data}
                        btnName={data?.isOrderingBranch === false && t(RESOURCE.MyK_Label_SC_Make_this_my_Branch)} />
                })}
            </div>
        </div>
    )
}

export default FulfillmentSummary